import { ReactElement, useEffect, useState } from 'react';

import PrivacySettings from 'components/GDPRPopup/PrivacySettings/PrivacySettings';

import { getGDPRSettings } from 'utils/localStorage';

import styles from './GDPRPopup.module.scss';

const GDPRPopup = (): ReactElement | null => {
  const [isGDPRVisible, setIsGDPRVisible] = useState(!getGDPRSettings());

  useEffect(() => {
    const settings = getGDPRSettings();

    if (!settings) {
      setIsGDPRVisible(true);
    }
  }, []);

  if (!isGDPRVisible) return null;

  return (
    <div className="custom-popup-container">
      <PrivacySettings
        setVisible={setIsGDPRVisible}
        setGDPR={setIsGDPRVisible}
      />
    </div>
  );
};

export default GDPRPopup;
